import "./App.css";
import Loader from "./components/loader";
import toast, { Toaster } from "react-hot-toast";
import webRoutes from "./routes/pageRoutes";
import { Suspense, useEffect } from "react";
import PrivateRoute from "./routes/PrivateRoute";
import { Route, Routes, useLocation } from "react-router";
import { AUTH_MODAL_PATHS, getSafeBackgroundLocation } from "./routes/authModal";
import { pipSetAccessToken } from "./utils/pip";

function App() {
  const location = useLocation();
  const { pathname } = location;
  const isAuthModal = AUTH_MODAL_PATHS.includes(pathname);
  const backgroundLocation = isAuthModal
    ? getSafeBackgroundLocation(location)
    : location?.state?.backgroundLocation || null;

  useEffect(() => {
    window.scroll(0, 0);
  }, [pathname]);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const tokenFromUrl =
      params.get("token") ||
      params.get("accessToken") ||
      params.get("access_token");

    if (tokenFromUrl) {
      pipSetAccessToken(tokenFromUrl);
    }

    const isPromoteSuccess =
      params.get("promote") === "success" ||
      (params.get("payment") === "success" &&
        window.location.pathname.includes("asset"));
    const isSubscriptionSuccess =
      params.get("payment") === "success" && !isPromoteSuccess;

    if (isPromoteSuccess) {
      toast.success("Asset promoted successfully! Your asset is now boosted.");
    } else if (isSubscriptionSuccess) {
      toast.success("Subscription activated successfully!");
    }

    if (
      tokenFromUrl ||
      params.get("payment") ||
      params.get("promote") ||
      params.get("session_id")
    ) {
      params.delete("token");
      params.delete("accessToken");
      params.delete("access_token");
      params.delete("payment");
      params.delete("promote");
      params.delete("session_id");
      const cleanSearch = params.toString() ? `?${params.toString()}` : "";
      window.history.replaceState(
        {},
        "",
        `${window.location.pathname}${cleanSearch}`
      );
    }
  }, []);

  const routes = webRoutes?.map((item, index) => (
    <Route
      key={index}
      exact
      path={item.path}
      element={
        item?.isPrivate ? (
          <PrivateRoute>{item?.element}</PrivateRoute>
        ) : (
          item?.element
        )
      }
    />
  ));

  return (
    <div className="App">
      <Toaster
        position="top-center"
        reverseOrder={false}
        containerStyle={{ zIndex: 99999 }}
      />
      <Suspense fallback={<Loader />}>
        <Routes location={backgroundLocation || location}>{routes}</Routes>
        <Routes>
          {backgroundLocation
            ? webRoutes
                ?.filter((item) => AUTH_MODAL_PATHS.includes(item.path))
                ?.map((item, index) => (
                  <Route
                    key={`modal-${index}`}
                    path={item.path}
                    element={item.element}
                  />
                ))
            : null}
        </Routes>
      </Suspense>
    </div>
  );
}

export default App;
